module.exports = __webpack_public_path__ + "static/media/titulo-recarga-programada@2x.a0e86d57.png";